import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSizeSetCreated.meta';

export type UseTrackSizeSetCreatedParams = {
  source: 'canvas_picker' | 'chat_follow_up' | 'context';
  size_set_id: string;
  member_count: number;
};

export const useTrackSizeSetCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackSizeSetCreated = useCallback(
    (params: UseTrackSizeSetCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSizeSetCreated };
};
